import type { ReactNode } from 'react';
import { hideTitleUnderMobileChrome } from '@reflex/ui/components/layout/PageLayout';
import { PageHeader } from '@/components/layout/PageLayout';
import { useRegisterPageChrome } from '@/components/layout/TakeoverShell/page-chrome';
import { BackLinkButton } from './BackLinkButton';

export interface NestedDetailBack {
  to: string;
  label?: string;
  ariaLabel?: string;
}

type NestedDetailHeaderProps = {
  back: NestedDetailBack;
  title: string;
  description?: string;
  docs?: string;
  icon?: ReactNode;
  iconVariant?: 'inline' | 'box';
  actions?: ReactNode;
};

/**
 * Nested list↔detail chrome: desktop parent-collection crumb above
 * `PageHeader`, plus a back arrow in the takeover mobile header. Title /
 * docs / info come from `PageHeader`'s chrome registration.
 */
export function NestedDetailHeader({
  back,
  title,
  description,
  docs,
  icon,
  iconVariant,
  actions,
}: NestedDetailHeaderProps) {
  useRegisterPageChrome({ back });

  return (
    <div className="flex flex-col gap-2">
      <div className={hideTitleUnderMobileChrome}>
        <BackLinkButton to={back.to} label={back.label} ariaLabel={back.ariaLabel} />
      </div>
      <PageHeader
        title={title}
        description={description}
        docs={docs}
        icon={icon}
        iconVariant={iconVariant}
        actions={actions}
        titleInMobileChrome
      />
    </div>
  );
}
